module.exports = __webpack_public_path__ + "img/clear_pic.875d9125.png";